import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="py-10" role="contentinfo" aria-label="Site footer">
      <div className="container-padding-x container mx-auto flex flex-col gap-6 lg:gap-8">
        {/* <div className="flex w-full flex-col items-center gap-12 text-center">
          <Link aria-label="Go to homepage" to="/">
            <img className="h-10" src="/images/logo.svg" alt="CAO Admin Logo" />
          </Link>
          <nav
            className="flex flex-col items-center gap-6 text-sm md:flex-row md:gap-8"
            aria-label="Footer navigation"
          >
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/"
            >
              Home
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/apply/apply-now"
            >
              Apply
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/faq"
            >
              FAQ
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/payments"
            >
              Payments
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/member-institutions"
            >
              Member Institutions
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/about"
            >
              About CAO
            </Link>
          </nav>
        </div> */}
        <div
          data-orientation="horizontal"
          role="presentation"
          data-slot="separator"
          className="bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px"
        />
        <div className="flex w-full flex-col-reverse items-center gap-12 text-sm lg:flex-row lg:justify-between lg:gap-6">
          <p className="text-muted-foreground text-center lg:text-left">
            <Link className="underline" target="_blank" to="/">
              Copyright © 2021 Central Applications Office
            </Link>{" "}
          </p>
          <nav
            className="flex flex-col items-center gap-6 text-sm md:flex-row md:gap-8"
            aria-label="Legal links"
          >
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/report-error"
            >
              Report an error
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/apply/how-to-apply"
            >
              Privacy Policy
            </Link>
            <Link
              className="text-muted-foreground hover:text-foreground transition-colors"
              to="/apply/terms-and-conditions"
            >
              Terms of Service
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
